import {List} from "immutable";

export * from "state/app/selectors/userIdentity"

export function getAvailableProducts(state) {
  return state.getIn(["app", "availableProducts"], new List() );
}

export function isMenuOpen(state) {
  return state.getIn(["app", "isMenuOpen"]);
}

export function isLoadingAvailableProducts(state) {
  return state.getIn(["app", "isLoadingAvailableProducts"]);
}

export function getClientInitDate(state) {
  return state.getIn(["app", "clientInitDate"]);
}

export function getFatalError(state) {
  return state.getIn(["app", "fatalError"]);
}

export function isDownTimeReporterOpen(state) {
  return state.getIn(["app", "isDownTimeReporterOpen"]);
}

export function getLastReadSchoolMoneyCustomerNoticesKey(state) {
  return state.getIn(["app", "lastReadSchoolMoneyCustomerNoticesKey"]);
}

export function getLastReadTeachers2ParentsCustomerNoticesKey(state) {
  return state.getIn(["app", "lastReadTeachers2ParentsCustomerNoticesKey"]);
}

export function getLastReadAppNoticesKey(state) {
  return state.getIn(["app", "lastReadAppNoticesKey"]);
}

export function isCustomerNoticesOpen(state) {
  return state.getIn(["app", "isCustomerNoticesOpen"]);
}

export function isInformationModalOpen(state) {
  return state.getIn(["app", "isInformationModalOpen"]);
}

export function getInformationModalMessage(state) {
  return state.getIn(["app", "informationModalMessage"]);
}

export function getInformationModalTitle(state) {
  return state.getIn(["app", "informationModalTitle"]);
}

export function isLoadingFrameOpen(state) {
  return state.getIn(["app", "isLoadingFrameOpen"]);
}



// WEBPACK FOOTER //
// ./src/state/app/selectors/index.js